import { useState } from 'react';
import { SaveCardOnboarding } from 'src/pages/OnboardingPage/OnboardingSteps/OnboardingStep7/OnboardingStep6Body/SaveCardOnboarding/SaveCardOnboarding';
import { ArrangeCallOnboarding } from 'src/pages/OnboardingPage/OnboardingSteps/OnboardingStep7/OnboardingStep6Body/ArrangeCallOnboarding/ArrangeCallOnboarding';

export const OnboardingStep6Body = () => {
  const [isSaveCardOpen, setIsSaveCardOpen] = useState(false);
  const [isArrangeCallOpen, setIsArrangeCallOpen] = useState(false);

  const onClick = (isSaveCard) => {
    setIsSaveCardOpen(isSaveCard);
    setIsArrangeCallOpen(!isSaveCard);
  };

  return (
    <div className={'w-full flex flex-col gap-4 items-center justify-center animate-fade-in'}>
      <SaveCardOnboarding open={isSaveCardOpen} onButtonClick={() => onClick(true)} />
      <div>
        <p className={'text-ebony_opacity_40 text-base font-bold text-center'}>OR</p>
      </div>
      <ArrangeCallOnboarding open={isArrangeCallOpen} onButtonClick={() => onClick(false)} />
    </div>
  );
};
